import { createFileRoute } from "@tanstack/react-router"
import { HealthPage } from "@/features/crawl-dashboard/HealthPage"

export const Route = createFileRoute("/crawl/health")({
	component: HealthPage,
})
